export const SUPPORT_EMAIL = process.env.NEXT_PUBLIC_PLATFORM === "rumble" ? "hello@rumble-video.download" :"hello@kick-video.download"